import { palette } from '_styles/variables'

import { AlertAppearance } from './types'

interface AlertData {
  bgColor: string
  borderColor: string
  icon:
    | 'fill-alert-triangle'
    | 'fill-error-circle'
    | 'fill-check-circle'
    | 'fill-info-circle'
  title: Capitalize<AlertAppearance>
}

export const mapper: Record<AlertAppearance, AlertData> = {
  error: {
    icon: 'fill-error-circle',
    bgColor: palette.ui.errorBg,
    borderColor: palette.ui.error,
    title: 'Error',
  },
  warning: {
    icon: 'fill-alert-triangle',
    bgColor: palette.ui.warningBg,
    borderColor: palette.ui.warning,
    title: 'Warning',
  },
  info: {
    icon: 'fill-info-circle',
    bgColor: palette.ui.blueBg,
    borderColor: palette.ui.blue,
    title: 'Info',
  },
  success: {
    icon: 'fill-check-circle',
    bgColor: palette.ui.successBg,
    borderColor: palette.ui.success,
    title: 'Success',
  },
}
